import { render } from "./SidebarGroupAction.vue?vue&type=template&id=2e82e2c2&ts=true"
import script from "./SidebarGroupAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarGroupAction.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarGroupAction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e82e2c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e82e2c2', __exports__)) {
    api.reload('2e82e2c2', __exports__)
  }
  
  module.hot.accept("./SidebarGroupAction.vue?vue&type=template&id=2e82e2c2&ts=true", () => {
    api.rerender('2e82e2c2', render)
  })

}


export default __exports__